import { EnvService, Stage } from './env.service';
import packageInfo from 'package.json';

export const EnvServiceFactory = () => {
  // Create env
  const env = new EnvService();

  // Read environment variables from browser window
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow['__env'] || {};

  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      env[key] = window['__env'][key];
    }
  }

  env['version'] = `${packageInfo.version}${getStageSuffix(env['stage'])}`;

  return env;
};

export const getStageSuffix = (stage: Stage) => {
  switch (stage) {
    case Stage.LOCAL:
      return ' - Locale';
    case Stage.DEVELOPMENT:
      return ' - Sviluppo';
    case Stage.STAGING:
      return ' - Collaudo';
    case Stage.PRODUCTION:
      return '';
    default:
      return ` - ${stage}`;
  }
};

export const EnvServiceProvider = {
  provide: EnvService,
  useFactory: EnvServiceFactory,
  deps: [],
};
